export const all = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },

  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },

  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
  },
];

export const drafts = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
];

export const requested = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
];

export const submitted = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
];

export const awarded = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
  {
    Header: 'Award Date',
    accessor: 'awardDate',
  },
];

export const archived = [
  {
    Header: 'Requested By',
    accessor: 'requestor',
  },
  {
    Header: 'RFQ Date',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Unit Price',
    accessor: 'unitPrice',
    Cell: cellprops => `$${Number(cellprops.value).toFixed(2)}`,
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Delivery Date',
    accessor: 'deliveryDate',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'NDA',
    accessor: 'ndaAccept',
  },
  {
    Header: 'Quote Status',
    accessor: 'status',
  },
  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
  },
];



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ColumnGrids/QuotesColumns.jsx